import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { UiAvatarComponent } from '../../atoms/avatar/avatar.component';
import { UiTooltipDirective } from '../../directives/tooltip/tooltip.directive';

export interface UiAvatarGroupParticipant {
  label: string;
  avatarSrc?: string | null;
}

/**
 * Molécula: avatares apilados con contador de desbordamiento.
 * Usa el átomo `ui-avatar`.
 */
@Component({
  selector: 'ui-avatar-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiAvatarComponent, UiTooltipDirective],
  templateUrl: './avatar-group.component.html',
  styleUrl: './avatar-group.component.scss',
  host: { class: 'ui-avatar-group-host' },
})
export class UiAvatarGroupComponent {
  readonly participants = input<readonly UiAvatarGroupParticipant[]>([]);
  readonly maxAvatars = input(3);
  /** Si es true, cada avatar visible emite `participantClick`. El contador no es accionable. */
  readonly clickable = input(false);
  readonly participantClick = output<UiAvatarGroupParticipant>();

  protected readonly visibleParticipants = computed(() =>
    this.participants().slice(0, Math.max(0, this.maxAvatars())),
  );

  protected readonly overflowCount = computed(() =>
    Math.max(0, this.participants().length - this.visibleParticipants().length),
  );

  protected onParticipantClick(participant: UiAvatarGroupParticipant): void {
    this.participantClick.emit(participant);
  }
}
